import {
  LoadLibrarysAction,
  LOAD_LIBRARY,
  loadLibrarysSuccess,
} from './actions';

import { put, takeLatest, all, call } from 'redux-saga/effects';
import { authService } from '../../index';
import { httpGet } from '../../Http/HttpClient';
import { ILookupItems } from '../../Models/LookupItem';
import { displayError } from '../../Helpers/Utilities';

function* loadLibrarySaga(action: LoadLibrarysAction) {
  try {
    const token: string = yield authService.getToken();
    const url: string = action.payload.clientId
      ? `${authService.appSettings.GetWebApiBaseUri()}/lookup/${action.payload.clientId}`
      : `${authService.appSettings.GetWebApiBaseUri()}/lookup`

    const response: { json: any } = yield call(httpGet,
      url,
      token
    );
    const lookupItems: ILookupItems = yield call([response, response.json]);
    yield put(loadLibrarysSuccess(lookupItems));
  }
  catch (error: any) {
    yield put(displayError(error));
  }
}
export function* watchLoadLibrary() {
  yield takeLatest(LOAD_LIBRARY, loadLibrarySaga);
}

export default function* librarySagas() {
  yield all([
    watchLoadLibrary()
  ])
}
